import React, { useEffect, useState } from "react"
import { PrimaryButton, SecondaryButton } from "../components/button/Button"

import useWebometrics from "../api/Webometrics"
import useIniciador from "../api/Iniciador"
import Spacer from "../components/Spacer"
import { Page } from "../components/page/Page"
import { useParams, useSearchParams } from "react-router-dom"
import styles from './More.module.css'
import * as DOMPurify from 'dompurify'
import { useConfigs } from "../components/config/Provider"

const More = () => {
    let [searchParams] = useSearchParams()
    const { cpf, cnpj } = useParams()
    const { sendEndMetrics, sendMoreMetrics } = useWebometrics()
    const { iniciar } = useIniciador()
    const configs = useConfigs()
    const [isLoading, setIsLoading] = useState(false)

    const token = searchParams.get("token")
    const company = searchParams.get("company")
    const consentId = searchParams.get("consent")

    useEffect(() => {
        localStorage.setItem("token", token)
        localStorage.setItem("company", company)
        localStorage.setItem("consent", consentId)
    }, [token, company, consentId])

    useEffect(() => {
        sendEndMetrics(company, { cpf, cnpj, consentId })
    }, [company, cpf, cnpj, consentId, sendEndMetrics])

    const onClickContinue = async () => {
        if(isLoading) return
        setIsLoading(true)
        sendMoreMetrics(company, { cpf, cnpj, consentId })
        const result = await iniciar(cpf, cnpj, token, company, consentId)
        window.location.href = result.link
    }

    const onClickEnd = () => {
        window.location.href = 'https://akropoli.tech/'
    }

    const rawHTML = DOMPurify.sanitize(`${configs.lastScreenText}`)

    return (
        <div>
            <div className={styles.header}>
                <img src={configs.lastScreenUrlImage.replace('pgn', 'png')} className={styles.logo} alt="more-logo" />
            </div>
            <Page>
                <div style={{ height: '200px' }}>
                    {<div dangerouslySetInnerHTML={{ __html: rawHTML }} />}
                </div>


                <PrimaryButton onClick={onClickContinue} isLoading={isLoading}>
                    {'Continuar'}
                </PrimaryButton>

                <Spacer height='20px' />


                <SecondaryButton onClick={onClickEnd}>
                    {'Finalizar'}
                </SecondaryButton>

            </Page>
        </div>
    )
}
export default More